// extracted by mini-css-extract-plugin
export var container = "_5i-0";
export var disabled = "_5i-4";
export var fullWidth = "_5i-3";
export var lined = "_5i-1";
export var selected = "_5i-5";
export var tab = "_5i-2";